import { render } from "./timeline_menu_content.vue?vue&type=template&id=2b8d0496"
import script from "./timeline_menu_content.js?vue&type=script&lang=js"
export * from "./timeline_menu_content.js?vue&type=script&lang=js"

import "./timeline_menu_content.vue?vue&type=style&index=0&id=2b8d0496&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__